module.exports = __webpack_public_path__ + "img/bouwen met hout.28ac61c1.jpg";